import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();
  
  return (
    <section id="about" className="py-16 sm:py-24 bg-gradient-to-b from-white to-amber-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-block mb-3 sm:mb-4">
            <span className="text-amber-600 font-semibold text-xs sm:text-sm tracking-wider uppercase">{t('about.badge')}</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t('about.title')} <strong>{t('about.titleBold')}</strong>
          </h2>
          <p className="text-base sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-2">
            {t('about.subtitle')}
          </p>
        </div>

        <div className="flex flex-col items-center mb-16 sm:mb-20">
          <div className="relative mb-8 sm:mb-12 px-4 sm:px-0">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl w-80 h-80 sm:w-96 sm:h-96 mx-auto">
              <img 
                src="https://static.readdy.ai/image/b9dffa7b6b8fd92109fabc077dd82307/4909c27707e74b37d75e72a9e9a85a7b.png"
                alt="Közde Kahve Hazırlama Sanatı"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-4 -right-2 sm:-bottom-6 sm:-right-6 w-24 h-24 sm:w-32 sm:h-32 bg-amber-600 rounded-3xl flex items-center justify-center shadow-xl">
              <div className="text-center">
                <div className="text-3xl sm:text-4xl font-bold text-white">36+</div>
                <div className="text-xs sm:text-sm text-amber-100">{t('about.experience')}</div>
              </div>
            </div>
          </div>

          <div className="space-y-4 sm:space-y-6 px-2 sm:px-0 max-w-4xl">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
              {t('about.sectionTitle')} <strong>{t('about.sectionTitleBold')}</strong>
            </h3>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg text-center">
              {t('about.paragraph1')}
            </p>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg text-center">
              {t('about.paragraph2')}
            </p>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg text-center">
              {t('about.paragraph3')}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 pt-4 sm:pt-6 max-w-3xl mx-auto">
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-xl text-amber-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">{t('about.feature1Title')}</h4>
                  <p className="text-xs sm:text-sm text-gray-600">{t('about.feature1Desc')}</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-xl text-amber-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">{t('about.feature2Title')}</h4>
                  <p className="text-xs sm:text-sm text-gray-600">{t('about.feature2Desc')}</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-xl text-amber-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">{t('about.feature3Title')}</h4>
                  <p className="text-xs sm:text-sm text-gray-600">{t('about.feature3Desc')}</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-xl text-amber-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">{t('about.feature4Title')}</h4>
                  <p className="text-xs sm:text-sm text-gray-600">{t('about.feature4Desc')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-amber-700 to-amber-900 rounded-3xl p-8 sm:p-12 text-center text-white shadow-2xl mx-2 sm:mx-0">
          <div className="max-w-3xl mx-auto">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
              <i className="ri-fire-fill text-4xl sm:text-5xl text-white"></i>
            </div>
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              {t('about.charcoalTitle')}
            </h3>
            <p className="text-base sm:text-lg text-amber-50 leading-relaxed mb-4 sm:mb-6">
              {t('about.charcoalDesc1')}
            </p>
            <p className="text-amber-100 text-sm sm:text-base">
              {t('about.charcoalDesc2')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
